/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import type { ComponentProps, ReactElement } from 'react';
import { cssMap } from '@compiled/react';

import { jsx } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';
import type { BlockCard as OriginalBlockCard } from '@atlaskit/renderer/nodes';

import type { LightNodeProps } from '../LightNodeObserver.ts';
import { InlineCard } from './InlineCard.tsx';

const styles = cssMap({
	card: {
		marginBlock: token('space.150'),
		padding: token('space.200'),
		borderWidth: token('border.width'),
		borderStyle: 'solid',
		borderColor: token('color.border'),
		borderRadius: token('radius.medium'),
		maxWidth: '100%',
	},
});

const ignoreInlineRef = () => {};

/** URL-backed cards defer resolution and previews until their subtree upgrades. */
export const BlockCard = ({
	lightNodeRef,
	localId,
	...props
}: ComponentProps<typeof OriginalBlockCard> & LightNodeProps): ReactElement => (
	<div
		ref={lightNodeRef}
		data-block-card
		data-card-url={props.url}
		data-local-id={localId}
		css={styles.card}
	>
		<InlineCard {...props} lightNodeRef={ignoreInlineRef} />
	</div>
);
